import React from 'react'
import PropTypes from 'prop-types'
import { CircularProgress } from '@material-ui/core'

import { Page, Header } from 'components'
import { Form } from './components/Form/Form'
import { useEditarLocal } from './hooks/useEditarLocal'
import useStyles from './EditarLocal.styles'

export const EditarLocal = (props) => {
  const { route } = props
  const classes = useStyles()

  const {
    local,
    carregandoLocal,
    idCaso,
  } = useEditarLocal(props)

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} />

      {carregandoLocal ? (
        <div className={classes.loadingContainer}>
          <CircularProgress size={45} />
        </div>
      ) : (
        <div className={classes.formContainer}>
          {/* Formulário Refatorado sem wrappers Card redundantes (Layout Flattening 🛸🚀) */}
          <Form local={local} idCaso={idCaso} />
        </div>
      )}
    </Page>
  )
}

EditarLocal.propTypes = {
  route: PropTypes.object.isRequired,
}
